var React = require('react');

function NavIconsWebhooks (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m18.56 18.84a1.15 1.15 0 1 0 0-2.3 1.14 1.14 0 0 0 -.95.5h-9.86v1.05a2.31 2.31 0 1 1 -3.6-2.3l-.67-.94a3.47 3.47 0 1 0 5.41 3.42h8.66a1.13 1.13 0 0 0 1.01.57zm-13.08 0a1.2 1.2 0 0 0 1.18-1.22 1.13 1.13 0 0 0 -.11-.48l4.92-8.52-.64-.37a2.3 2.3 0 1 1 2.44-3.91 2.27 2.27 0 0 1 1.08 1.75l1.15-.09a3.46 3.46 0 1 0 -5.65 3l-4.35 7.48a1.19 1.19 0 0 0 -1 .58 1 1 0 0 0 -.07.15 1.15 1.15 0 0 0 .57 1.53 1.12 1.12 0 0 0 .48.1zm16.08-3.05a3.44 3.44 0 0 0 -4.22-1.47l-4.34-7.48a1.15 1.15 0 1 0 -1.56.46 1.07 1.07 0 0 0 .49.14l4.87 8.43.58-.33a2.28 2.28 0 1 1 .15 4.05l-.49 1a3.46 3.46 0 0 0 4.48-4.84z","fillRule":"evenodd"}));
}

NavIconsWebhooks.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsWebhooks;

NavIconsWebhooks.default = NavIconsWebhooks;
